import Vue from "vue";
import App from "./App.vue";
import store from "./store/store";
import "@/assets/styles/global.scss";

// Uncomment the below lines for Facebook social share, and google analytics
import { embed as googleEmbed, trackPage } from "./js/tracking/gtag";
import { embed as facebookEmbed } from "./js/social/facebook";

googleEmbed(process.env.VUE_APP_GOOGLE_ANALYTICS_ID);
facebookEmbed(process.env.VUE_APP_FB_ID);

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");

trackPage();
